import CompetitionConsideration from './competitionConsideration'

export default CompetitionConsideration
